// eslint-ignore
export default 
`<MultiSelect v-model="selected" :value="selected" :options="options" canClear/>
<p>Selected: {{ selected }} </p>


export default {
    components: { MultiSelect },
  
    data() {
      return { 
        selected: null,
        options: [
          { text: 'Aerospace', value: 'item_1' },
          { text: 'Agriculture', value: 'item_2' },
          { text: 'Computer and Technology', value: 'item_3' },
          { text: 'Construction', value: 'item_4' },
          { text: 'Economics', value: 'item_5' },
          { text: 'Education', value: 'item_6' },
          { text: 'Energy', value: 'item_7' },
          { text: 'Entertainment', value: 'item_8' },
          { text: 'Fashion', value: 'item_9' },
          { text: 'Finance', value: 'item_10' },
          { text: 'Food Industry', value: 'item_11' },
          { text: 'Gaming', value: 'item_12' },
          { text: 'Health Care', value: 'item_13' },
          { text: 'Hospitality', value: 'item_14' },
          { text: 'Insurance', value: 'item_15' },
          { text: 'Investment', value: 'item_16' }
        ]
      }
    }
}`;